/** Strips every non-digit, mirroring the `gsub(/\D/,'').to_i` the models apply to price strings. */
export function parseAmount(value: string): number {
  const digits = value.replace(/\D/g, '')
  return digits.length > 0 ? Number(digits) : 0
}

/** Thousands-grouped digits without a currency sign, as the legacy `format_money` keyup produced. */
export function formatMoney(value: string): string {
  const digits = value.replace(/\D/g, '')
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export function hcCurrency(amount: number): string {
  const grouped = Math.round(amount)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return `$${grouped}`
}
